import { requestApi } from '../util/network'

// 根据ap_id 获取 广告列表
export const getAppadList =
  (apId) =>
    requestApi(
      '/Index/getAppadList',
      'POST',
      {
        ap_id: apId
      }
    )
// 首页导航栏
export const homeIndexNavList =
    () =>
      requestApi(
        '/Index/getNavList',
        'POST',
        {
        }
      )
// 获取猜你喜欢
export const getGuessLike =
    (memberId = 0) =>
      requestApi(
        '/Index/getGuessLike',
        'POST',
        {
          member_id: memberId
        }
      )
// 获取首页商品列表
export const homeIndexGoodsList =
    () =>
      requestApi(
        '/Index/getGoodsList',
        'POST',
        {
        }
      )
